import { array, concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { includes } from '@nullvoxpopuli/ember-composable-helpers';
import can from 'ember-can/helpers/can';
import { t } from 'ember-intl';
import { eq, lt } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import ContextMenu from 'umg-ember-backend/components/ui/context-menu';
import Checkbox from 'umg-ember-backend/components/ui/form/field/checkbox';
import lookupTranslation from 'umg-ember-backend/helpers/lookup-translation';

export default class RecordExplorerToolbarActionsComponent extends Component {
  // Services
  @service breadcrumb;
  @service router;

  // Defaults
  blockName = 'c-record-explorer-toolbar-actions';

  //  Getter and setter
  get hasCloseButton() {
    return (
      this.breadcrumb.currentRoute.isExplorerRoute &&
      this.breadcrumb.currentRoute !== this.breadcrumb.firstRoute
    );
  }

  // Functions
  changeColumns = (property) => {
    let columns = this.args.activeColumns;

    const index = columns.indexOf(property);
    if (index !== -1) {
      columns.splice(index, 1);
    } else {
      columns.push(property);
    }

    this.args.onChangeColumns(columns);
  };

  goToPrevRoute = () => {
    this.router.transitionTo(...this.breadcrumb.prevRoute.transitionToParams);
  };

  // Template
  <template>
    {{#if (can 'create' @recordType)}}
      <Button
        @label={{t 'record_explorer.toolbar.actions.new'}}
        @icon='add'
        data-test-add-record
        {{on 'click' @onAddRecord}}
      />
    {{/if}}

    {{#if @onAssignRelation}}
      {{#if (can 'update' @parentRecordType)}}
        <Button
          @label={{t
            'record_explorer.toolbar.actions.assign_relation'
            relationCount=@selectedRecords.length
          }}
          @disabled={{lt @selectedRecords.length 1}}
          data-test-select-records
          {{on 'click' (fn @onAssignRelation @selectedRecords)}}
        />
      {{/if}}
    {{/if}}

    {{yield}}

    {{#if this.hasCloseButton}}
      <Button
        @style='grey'
        @icon='close'
        data-test-go-to-prev-route
        {{on 'click' this.goToPrevRoute}}
      />
    {{/if}}

    <ContextMenu @horizontalPosition='right' data-test-open-columns-select>
      <:trigger>
        <Button @style='grey' @icon='columns' @label={{t 'tables.columns'}} />
      </:trigger>

      <:content as |content|>
        {{#each @columns as |column|}}
          {{#unless (eq column.type 'row-actions')}}
            <content.Item
              @label={{lookupTranslation
                (array
                  (concat 'tables.' @recordType)
                  'tables.defaults'
                  (concat 'forms.' @recordType)
                  'forms.defaults'
                )
                (concat 'fields.' column.property)
              }}
            >
              <Checkbox
                @isChecked={{includes column.property @activeColumns}}
                @onChange={{fn this.changeColumns column.property}}
                data-test-toggle-column={{column.property}}
              />
            </content.Item>
          {{/unless}}
        {{/each}}
      </:content>
    </ContextMenu>
  </template>
}
